<template>
  <div class="flex flex-col min-h-0">
    <div
      class="grid auto-rows-auto gap-2 text-xs font-medium pointer-events-none"
    >
      <ul v-if="hasPriorityTags" class="flex flex-wrap gap-2 list-none">
        <RedesignAccomCardTag
          v-if="tags.discount"
          as="li"
          class="inline-flex bg-hlt-hover text-hlt-contrast pointer-events-auto"
        >
          {{ tags.discount }}%
        </RedesignAccomCardTag>

        <RedesignAccomCardTag
          v-if="tags.topRated"
          as="li"
          class="inline-flex bg-suc text-suc-contrast uppercase pointer-events-auto"
        >
          {{ $t(`${trPrefix}toprated`) }}
        </RedesignAccomCardTag>

        <RedesignAccomCardTag
          v-if="tags.new"
          as="li"
          class="inline-flex bg-suc text-suc-contrast uppercase pointer-events-auto"
        >
          {{ $t(`${trPrefix}new`) }}
        </RedesignAccomCardTag>
      </ul>

      <ul v-if="tags.freeCancellation" class="flex flex-wrap gap-2 list-none">
        <RedesignAccomCardTag
          as="li"
          class="inline-flex gap-1 bg-suc-reduced border border-suc capitalize pointer-events-auto"
        >
          <WebccIcon name="site/tick" class="text-suc h-4 w-4"></WebccIcon>
          {{ $t(`${trPrefixFreeCancellation}short`) }}
        </RedesignAccomCardTag>
      </ul>
    </div>

    <ul
      v-if="tags.duration"
      class="flex flex-wrap gap-2 list-none mt-auto pointer-events-none"
    >
      <RedesignAccomCardTag
        as="li"
        class="inline-flex bg-bgr opacity-80 text-xs font-semibold pointer-events-auto"
      >
        {{ tags.duration }}
      </RedesignAccomCardTag>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { pickBy, pick } from 'lodash-es'

const trPrefix = 'www.components.hitbox.Tags.'
const trPrefixFreeCancellation = 'plugins.components.FreeCancellationInfo.'

const props = defineProps<{
  accom?: ResultDocument
  trip?: TripParams | Trip
  cancelConditions?: CancelCondition[]
}>()

const freeCancellation = useFreeCancellation(props.trip, props.cancelConditions)

const tags = computed<RedesignAccomTags>(() => {
  return {
    discount: props.accom?.trip?.reduction?.toFixed(),
    topRated: props.accom?.tags.includes('top'),
    new: props.accom?.tags.includes('new'),
    duration:
      props.trip && formatDateRange(getTripDateRange(props.trip), 'monthDay'),
    freeCancellation: freeCancellation.isEnabled,
  }
})

const hasPriorityTags = computed(
  () =>
    Object.keys(
      pickBy(pick(tags.value, ['discount', 'topRated', 'new']), Boolean),
    ).length > 0,
)
</script>
